export default {
    methods: {
        toCurrency(value, currency = '₴', locale = 'uk-UA', fixedCount = 0) {
            if (typeof value !== "number") {
                return value;
            }
            const formatter = new Intl.NumberFormat(locale, {
                minimumFractionDigits: fixedCount
            });
            return formatter.format(value) + ' ' + currency;
        }
    }
}
